import {ConfirmationDialogInstance} from "./ConfirmationDialogInstance";
import {Dialog} from "../../core/Dialog";
import * as React from "react";



import {faQuestion} from "@fortawesome/free-solid-svg-icons/faQuestion";
import {faTrash} from "@fortawesome/free-solid-svg-icons/faTrash";
import {faCheck} from "@fortawesome/free-solid-svg-icons/faCheck";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";


export class ConfirmationDialog {
    public ConfirmationDialogOptions:ConfirmationDialogOptions;
    private _enableCancelButton:boolean=true;
    private _applyText:string='Close';
    private constructor(title:string,content:string){
        this.ConfirmationDialogOptions={
            Title:title,
            Content:content,
            Icon:<FontAwesomeIcon icon={faCheck}/>,
            OnApply:null
        }

    }

    public static Create(title:string='',content:any){
        if(title=='')
            title='Please confirm';
        return new ConfirmationDialog(title,content);
    }

    public SetApplyText(text:string){
        this._applyText=text;
        return this;
    }

    public SetIcon(icon:JSX.Element)
    {
        this.ConfirmationDialogOptions.Icon=icon;
        return this;
    }

    public Show():Promise<any>{
        return Dialog.Show(<ConfirmationDialogInstance ApplyText={this._applyText}   EnableCancelButton={this._enableCancelButton}  Options={this.ConfirmationDialogOptions}/>);
    }

    public EnableCancelButton(showCancelButton:boolean){
        this._enableCancelButton=showCancelButton;
        return this;
    }

    public OnApply(callBack:()=>Promise<boolean>){
        this.ConfirmationDialogOptions.OnApply=callBack;
        return this;
    }

    UseDeleteIcon() {
        this.ConfirmationDialogOptions.Icon=<FontAwesomeIcon icon={faTrash}/>;
        return this;
    }
}


export interface ConfirmationDialogOptions{
    Title:string;
    Content:any;
    Icon:JSX.Element
    OnApply:()=>Promise<boolean>;
}